module.exports = {
	"favorite": "Favorite",
	"rejected": "Rejected",
	"cancel": "Cancel",
	"project_manager_initials": "PM"
};


//////////////////
// WEBPACK FOOTER
// ./public/locales/en/common.json
// module id = 2008
// module chunks = 0